import { useEffect } from 'react';
import { authService } from '../services/authService';
import { useAuthStore } from '../stores/authStore';

/**
 * Re-reads the server's feature flags once per shell mount. The login payload carries them, but
 * the auth store is persisted, so a flag flipped on the server after login would otherwise wait
 * for the next sign-in. Only `features` is merged; nothing else about the session changes.
 */
export function useFeatureRefresh(): void {
  const { user, token, refreshToken, setAuth } = useAuthStore();
  useEffect(() => {
    if (!user || !token) return;
    let cancelled = false;
    authService.getCurrentUser()
      .then((res) => {
        const features = (res.data as any)?.data?.features;
        if (cancelled || !features) return;
        const same = JSON.stringify(features) === JSON.stringify(user.features ?? {});
        if (!same) setAuth(token, { ...user, features }, refreshToken ?? undefined);
      })
      .catch(() => { /* offline or expired: keep what we have */ });
    return () => { cancelled = true; };
    // Once per mount on purpose.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
